import React from 'react';
import logo from '../img/logo.png';

const Header = () => (
  <header className="header">
    <div className="header__inner">
      <img src={logo} alt="logo" className="header__logo" />
      <nav className="header__nav">
        <ul>
          <li><a href="#winners">Победители</a></li>
          <li><a href="#nominations">Номинации</a></li>
          <li><a href="#jury">Жюри</a></li>
          <li><a href="#application">Подать заявку</a></li>
          <li><a href="#contacts">Контакты</a></li>
        </ul>
      </nav>
    </div>
  </header>
);

export default Header;